import Vue from "vue";
import format from "date-fns/format";
import { DATE_FORMAT, DATE_TIME_FORMAT, TIME_FORMAT, DATE_DAY_FORMAT } from "@/Constants";

Vue.filter("date", (date: string | null) => {
  if (!date) return "";
  return format(new Date(date), DATE_FORMAT);
});

Vue.filter("datetime", (date: string | null) => {
  if (!date) return "";
  return format(new Date(date), DATE_TIME_FORMAT);
});

Vue.filter("time", (date: string | null) => {
  if (!date) return "";
  return format(new Date(date), TIME_FORMAT);
});

Vue.filter("dateday", (date: Date | null) => {
  if (!date) return "";
  return format(new Date(date), DATE_DAY_FORMAT);
});
